import { has, isArrayLike } from 'lodash'

export interface ClaimDto {
  CodiceClaim: string
  Etichetta: string
  Obbligatorio: boolean
  Ordine: number
}

export interface GetAuthorizeConsentsOutput {
  Claims: ClaimDto[]
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isAuthorizeConsentsOutput = (output: any): output is GetAuthorizeConsentsOutput =>
  has(output, 'Claims') && isArrayLike(output['Claims'])
